import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  UPDATE_USER,
  UPDATE_NAME,
  TWO_FACTOR_AUTH,
} from "../actions/Auth/authTypes";
import jwtDecode from "jwt-decode";

const token = JSON.parse(localStorage.getItem("user"));
// const user = jwtDecode(token ? JSON.parse(localStorage.getItem("user")) : null)
let user;
token ? (user = jwtDecode(token)) : (user = null);
const initialState = token
  ? {
      isLoggedIn: true,
      token,
      user,
    }
  : {
      isLoggedIn: false,
      token: null,
      user: null,
      twoFactorAuth: false,
      twoFactorEmail: "",
    };

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REGISTER_SUCCESS:
    case REGISTER_FAIL:
      return { ...state, isLoggedIn: false };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        token: payload.user,
        user: jwtDecode(payload.user.data.token),
      };
    case UPDATE_NAME:
      return {
        ...state,
        user: {
          ...state.user,
          fullName: payload,
        },
      };
    case UPDATE_USER:
      localStorage.removeItem("user");
      localStorage.setItem("user", JSON.stringify(payload.token));
      const data = jwtDecode(payload.token);
      return {
        ...state,
        user: {
          ...state.user,
          fullName: data.fullName,
          role: data.role,
        },
      };
    case TWO_FACTOR_AUTH:
      return {
        ...state,
        twoFactorAuth: payload.twoFactorAuth,
        twoFactorEmail: payload.twoFactorEmail,
      };
    case LOGOUT:
      return { ...state, isLoggedIn: false, token: null, user: null };
    case "SET_STRIPE_ID":
      return { ...state, user: { ...state.user, stripeId: payload.stripeId } };
    default:
      return state;
  }
};
export default authReducer;
